import React from 'react';
import NavigationItem from '../NavigationItem/NavigationItem';

export default function CommunityMenu() {
    return (
        <div className="menu menu--constrained">
            <div className="menu__inner">
                <ul className="menu__item menu__item--action-list">
                    <NavigationItem
                        label={__('Forum')}
                        url="https://99designs.community"
                        icon="consultation-1"
                        linkAttributes={{ target: '_blank' }}
                    />

                    <NavigationItem label={__('Discover')} url="/discover" icon="search-1" />

                    <NavigationItem
                        label={__('Recent winners')}
                        url="/browse/winners"
                        icon="trophy-1"
                    />
                </ul>
            </div>
        </div>
    );
}
